import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/eventbus.ts